import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  tableCellClasses,
  TableRow,
  TableContainer,
  Paper,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  Typography,
  IconButton,
  CircularProgress,
  MenuItem,
  Select,
  Alert,
  ListItem,
  List,
  Backdrop,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { LabelWithControl } from "components/common/LabelControl";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showNotificationDialogManualOrder } from "redux/actions/notificationManualOrderAction";
import {
  PAGE,
  ORDER_ACTIONS,
  SUPPLYCHAIN,
  WHOLESALE,
  ONLINE,
} from "components/common/CONSTANTS";
import { orderOpportunitiesInCreate } from "redux/actions/createAction";
import { showNotificationDialogEmergencyOrder } from "redux/actions/notificationEmergencyOrderActions";
import {
  resetCreateManualOrder,
  resetOrderOpportunities,
} from "redux/actions/createAction";
import { createProcessOrder } from "redux/actions/createProcessOrderAction";
import { showNotificationDialog } from "redux/actions/notificationActions";
import { showErrorMessageByCode } from "services/commonServices";
import { RESET_ORDEROPPORTUNITIES_MANUAL_ORDER } from "redux/actions/action-type";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&:first-of-type": {
    width: "4%!important",
    padding: "0px",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.default,
    fontSize: 12,
    border: "1px solid #A9A9A9",
    fontWeight: "bold",
    whiteSpace: "nowrap",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    border: "1px solid #A9A9A9",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: "1px solid #A9A9A9",
  },
}));

const ConfirmationDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <p>You want to proceed with pre-populate qty?</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          No
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            onClose();
          }}
          color="primary"
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export const CreateManualScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tableContainerRef = useRef();
  const [disableConfirmButton, setDisableConfirmButton] = useState(true);
  const [mandatoryFieldsError, setMandatoryFieldsError] = useState("");
  const userType = useSelector((state) => state.user);
  const { locationResponse } = useSelector((state) => state.locations);
  const { accessiblePages } = userType.userType;
  const isorderOpportunitiesError = useSelector(
    (state) => state.orderOpp.isorderOpportunitiesError
  ); // Adjust based on your state shape
  const errorDetails = useSelector((state) => state.orderOpp.errorDetails);
  const createProcessOrderResponse = useSelector(
    (state) => state.createProcessOrder.createProcessOrderResponse.orders
  ); // Adjust based on your state shape
  const createManualOrderMetaData = useSelector(
    (state) => state.createProcessOrder.createProcessOrderResponse.metadata
  );
  const isCreateProcessOrderSuccess = useSelector(
    (state) => state.createProcessOrder.isCreateProcessOrderSuccess
  );
  const isorderOpportunitiesSuccess = useSelector(
    (state) => state.orderOpp.isorderOpportunitiesSuccess
  );
  const isCreateProcessOrderError = useSelector(
    (state) => state.createProcessOrder.isCreateProcessOrderError
  );
  const isCreateProcessOrder = useSelector(
    (state) => state.createProcessOrder.createProcessOrderResponse
  );
  const { isorderOpportunitiesLoading } = useSelector(
    (state) => state.orderOpp
  );
  const { items, metadata } = useSelector((state) => state.orderOpp);
  const errMessageForCreate = useSelector(
    (state) => state.createProcessOrder.errorMessage
  );
  const [rows, setRows] = useState([]);
  const [pinField, setPinField] = useState("");
  const [minField, setMinField] = useState("");
  const [depotField, setDepotField] = useState("");
  const [storeField, setStoreField] = useState("");
  const [quantityField, setQuantityField] = useState("");
  const [orderDateField, setOrderDateField] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [pinError, setPinError] = useState("");
  const [minError, setMinError] = useState("");
  const [depotError, setDepotError] = useState("");
  const [storeError, setStoreError] = useState("");
  const [quantityError, setQuantityError] = useState("");
  const [duplicateError, setDuplicateError] = useState("");
  const [storeTypeNew, setStoreTypeNew] = useState("");
  const [openStatus, setOpenStatus] = useState(true); // State to control alert visibility
  const [openDialog, setOpenDialog] = useState(false);
  const [confirmQty, setConfirmQty] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [popUpFlag, setPopUpFlag] = useState(false);
  const [headers, setHeaders] = useState([]);
  const [headerMapping, setHeaderMapping] = useState([]);
  const [prePopulateQuantity, setPrePopulateQuantity] = useState("");
  const [validStoresObj, setValidStoresObj] = useState({});
  const [storeTypes, setStoreTypes] = useState([]);
  const [successPopupFlag, setSuccessPopupFlag] = useState(false);
  const [offset, setOffset] = useState(0);
  const [storesFromStoreType, setStoresFromStoreType] = useState("");
  const [storeIds, setStoreIds] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [isDataLoadingByScroll, setDataLoadingByScroll] = useState(false);
  let limit = 100;

  if (createProcessOrderResponse !== undefined) {
    if (
      createProcessOrderResponse.length === undefined ||
      createProcessOrderResponse.length > 0
    ) {
      if (
        createProcessOrderResponse.length !== undefined &&
        createProcessOrderResponse.length !== 0 &&
        isCreateProcessOrderSuccess
      ) {
        navigate(PAGE.ERROR_FEEDBACK.url, {
          state: {
            action: ORDER_ACTIONS.CREATE,
          },
        });
      }
    }
  }

  useEffect(() => {
    if (isorderOpportunitiesLoading) {
      setShowSpinner(true);
    } else if (isorderOpportunitiesSuccess) {
      setShowSpinner(false);
      setDataLoadingByScroll(false);
    } else if (errorDetails) {
      setShowSpinner(false);
      setDataLoadingByScroll(false);
    }
  }, [isorderOpportunitiesLoading, isorderOpportunitiesSuccess, errorDetails]);

  useEffect(() => {
    return () => {
      dispatch({ type: RESET_ORDEROPPORTUNITIES_MANUAL_ORDER });
    };
  }, [dispatch]);

  useEffect(() => {
    if (accessiblePages) {
      let channelList = accessiblePages[PAGE.CREATE_MANUAL_ORDERS.key];
      const storeTypeList = [];
      if (channelList.includes(SUPPLYCHAIN)) {
        storeTypeList.push({
          id: 10,
          name: "Core Stores except Gibralter",
          channel: SUPPLYCHAIN,
        });
        storeTypeList.push({ id: 20, name: "Gibralter", channel: SUPPLYCHAIN });
      }
      if (channelList.includes(WHOLESALE)) {
        storeTypeList.push({ id: 30, name: "Wholesale", channel: WHOLESALE });
      }
      if (channelList.includes(ONLINE)) {
        storeTypeList.push({ id: 40, name: "Online", channel: ONLINE });
      }

      setStoreTypes([{ id: "", name: "Select Store Type" }, ...storeTypeList]);

      const storesObj = {};
      locationResponse.forEach(function (location) {
        if (channelList.indexOf(location.channel.toLowerCase()) > -1) {
          if (storesObj[location.channel.toLowerCase()]) {
            const tempStores = storesObj[location.channel.toLowerCase()];
            storesObj[location.channel.toLowerCase()] = [
              ...tempStores,
              location.locationId,
            ];
          } else {
            storesObj[location.channel.toLowerCase()] = [location.locationId];
          }
        }
      });
      setValidStoresObj(storesObj);
    }
  }, [accessiblePages, locationResponse]);

  useEffect(() => {
    if (storeTypes.length > 0) {
      setStoreTypeNew(storeTypes[0].id);
    }
  }, [storeTypes]);

  useEffect(() => {
    if (isorderOpportunitiesSuccess && items) {
      let rowData = [];
      let duplicateRowData = [];
      items?.forEach((item) => {
        if (item.hasOwnProperty("manualOrderId")) {
          duplicateRowData.push(item);
        } else {
          rowData.push(item);
        }
      });

      const finalRowList = [...rows, ...rowData];

      const updatedRows = finalRowList?.map((row, index) => ({
        id: index + 1,
        quantity: "",
        ...row,
        ...(confirmQty && !row.quantity
          ? { quantity: prePopulateQuantity }
          : {}),
      }));

      setRows(updatedRows);
      const allBlankOrZero = updatedRows.every(
        (row) => !row.quantity || row.quantity === "0"
      );

      setDisableConfirmButton(allBlankOrZero);

      if (duplicateRowData.length > 0) {
        const formatDate = (dateStr) => {
          return dayjs(dateStr).format("DD/MM/YYYY");
        };
        const selectedDataForDuplicate = duplicateRowData?.map((item) => {
          return {
            orderDate: formatDate(item?.orderDate),
            itemId: item?.itemId,
            packId: item?.packId,
            shipToLocationId: item?.shipToLocationId,
            quantityOrdered: item?.quantityOrdered,
          };
        });
        setSelectedData([...selectedData, ...selectedDataForDuplicate]);
      }
    }
  }, [isorderOpportunitiesSuccess, items]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (selectedData?.length !== 0) {
      setDuplicateError(
        "Manual orders with the combination of order date, item and store id already exists"
      );
      const headerMapping = {
        orderDate: "Order date",
        itemId: "Min",
        packId: "Pin",
        shipToLocationId: "Store",
        quantityOrdered: "Qty in cases",
      };
      setHeaderMapping(headerMapping);

      const headers = Object.keys(headerMapping);

      setHeaders(headers);
    } else {
      setDuplicateError("");
    }
  }, [selectedData]);

  useEffect(() => {
    let multipleErrorsMsg;
    let errorList;
    if (createManualOrderMetaData?.validationfailed === 0) {
      errorList = [
        `Total number of manual orders = ${createManualOrderMetaData?.totalrecordsRecieved}`,
        `Manual orders created = ${createManualOrderMetaData?.totalrecordsProcessed}`,
      ];
    }
    let errorListItems = errorList?.map((x, index) => (
      <ListItem
        dense
        sx={{ p: 0, display: "list-item" }}
        key={index}
      >{`${x}`}</ListItem>
    ));
    if (successPopupFlag) {
      multipleErrorsMsg = (
        <>
          <Typography variant="span">
            Manual Orders submitted successfully, refer below for the exact
            status:{" "}
          </Typography>
          <List dense sx={{ listStyleType: "disc" }}>
            {errorListItems}
          </List>
        </>
      );
    }

    if (
      createProcessOrderResponse?.length === undefined ||
      createProcessOrderResponse?.length === 0
    ) {
      if (
        isCreateProcessOrderSuccess &&
        createProcessOrderResponse?.length === 0 &&
        createManualOrderMetaData?.validationfailed === 0 &&
        successPopupFlag
      ) {
        dispatch(
          showNotificationDialogManualOrder(
            "Manual Orders Created Successfully",
            multipleErrorsMsg,
            "Done"
          )
        );
        setSuccessPopupFlag(false);
        dispatch(resetCreateManualOrder());
      }
    }
  }, [
    successPopupFlag,
    dispatch,
    createProcessOrderResponse,
    createManualOrderMetaData,
    isCreateProcessOrderSuccess,
  ]);

  useEffect(() => {
    if (
      errorDetails &&
      errorDetails.errorMessage === "Incorrect MIN/PIN number."
    ) {
      setMinError(errorDetails.errorMessage);
    }
  }, [errorDetails, setMinError]);

  useEffect(() => {
    if (rows.length < 10 && selectedData.length > 0) {
      setOffset(rows.length + selectedData.length);
    }
  }, [rows, selectedData]);

  const validInputRegex = /^[0-9, \s]*$/;

  const handleReset = () => {
    setPinField("");
    setMinField("");
    setDepotField("");
    setStoreField("");
    setQuantityField("");
    setOrderDateField(null);
    setMandatoryFieldsError("");
    setPinError("");
    setMinError("");
    setDepotError("");
    setStoreError("");
    setQuantityError("");
    setDuplicateError("");
    setIsDisabled(false);
    setIsVisible(true);
    setStoreTypeNew("");
    dispatch(resetOrderOpportunities());
  };

  const handlePinChange = (e) => {
    const pin = e.target.value;
    setPinField(e.target.value);
    if (validInputRegex.test(e.target.value)) {
      setPinError("");
      setMinError("");
    } else {
      setPinError("Incorrect PIN number.");
    }
    e.target.value === "" ? setPinError("") : setMandatoryFieldsError("");

    const pinArray = pin ? pin.split(",").map((num) => Number(num.trim())) : [];
    if (pinArray.length > 50) {
      setPinError("PIN can have a maximum of 50 entries.");
    }
  };

  const handleMinChange = (e) => {
    const min = e.target.value;
    setMinField(e.target.value);
    if (validInputRegex.test(e.target.value)) {
      setPinError("");
      setMinError("");
    } else {
      setMinError("Incorrect MIN number.");
    }
    e.target.value === "" ? setMinError("") : setMandatoryFieldsError("");

    const minArray = min ? min.split(",").map((num) => Number(num.trim())) : [];
    if (minArray.length > 50) {
      setMinError("MIN can have a maximum of 50 entries.");
    }
  };

  const handleDepotChange = (e) => {
    const depot = e.target.value;
    setDepotField(e.target.value);
    validInputRegex.test(e.target.value) === false
      ? setDepotError("Incorrect Depot Id ")
      : setDepotError("");
    if (e.target.value === "") {
      setDepotError("");
    }

    const depotArray = depot
      ? depot.split(",").map((num) => Number(num.trim()))
      : [];
    if (depotArray.length > 50) {
      setDepotError("Depot can have a maximum of 50 entries.");
    }
  };

  const handleStoreChange = (e) => {
    setStoreField(e.target.value);
    validInputRegex.test(e.target.value) === false
      ? setStoreError("Incorrect Store Id ")
      : setStoreError("");
    if (e.target.value === "") {
      setStoreError("");
    }
    if (e.target.value !== "") {
      setMandatoryFieldsError("");
    }
  };
  const handleDateChange = (x) => {
    const selectedDate = dayjs(x.$d);

    if (selectedDate.isBefore(dayjs(), "day")) {
      setError(true);
      setErrorMessage("Please enter current or future date");
    } else if (selectedDate && !dayjs(selectedDate).isValid()) {
      setError(true);
      setErrorMessage("Please enter date in correct format");
    } else {
      setError(false);
      setErrorMessage("");
      setOrderDateField(selectedDate.format("DD/MM/YYYY"));
    }
  };

  const handlePrepopulateQuantity = (e) => {
    const regex = /^(0?[1-9]{1,4}|[1-9][0-9]{0,3})$/;
    setQuantityField(e.target.value);
    regex.test(e.target.value) === false
      ? setQuantityError("Please enter valid Quantity")
      : setQuantityError("");
    if (e.target.value === "") {
      setQuantityError("");
    }
  };
  const handleStoreTypeChange = (event) => {
    setStoreTypeNew(event.target.value);
    setMandatoryFieldsError("");
  };

  const handleCreate = (e) => {
    if (
      quantityField !== "" &&
      (minField || pinField) &&
      (storeField || storeTypeNew) &&
      mandatoryFieldsError === "" &&
      errorMessage === "" &&
      minError === "" &&
      pinError === "" &&
      depotError === ""
    ) {
      setOpenDialog(true);
      setConfirmQty(false);
    } else {
      performCreate();
    }
  };

  const performCreate = () => {
    dispatch(resetOrderOpportunities());
    setRows([]);
    setSelectedData([]);
    setDuplicateError("");
    const updatedOffset = 0;
    setOffset(updatedOffset);
    let validStoresSearched = [];
    if (!pinField && !minField) {
      setMandatoryFieldsError("Please enter MIN/PIN number.");
    } else if (!storeField && !storeTypeNew) {
      setMandatoryFieldsError("Please enter store or select store type.");
    } else {
      setPrePopulateQuantity(quantityField);

      if (storeTypeNew) {
        const selectedStoreType = storeTypes.filter(
          (item) => item.id === storeTypeNew
        );
        let stores = [];

        if (selectedStoreType && selectedStoreType.length > 0) {
          if (
            selectedStoreType[0].name === "Gibralter" &&
            selectedStoreType[0].channel === SUPPLYCHAIN
          ) {
            stores.push(452);
          } else if (
            selectedStoreType[0].name === "Core Stores except Gibralter" &&
            selectedStoreType[0].channel === SUPPLYCHAIN
          ) {
            stores.push(
              ...validStoresObj[selectedStoreType[0].channel].filter(
                (store) => store !== 452
              )
            );
          } else {
            stores.push(...validStoresObj[selectedStoreType[0].channel]);
          }
        }
        setStoresFromStoreType(stores);
        if (storeTypeNew) {
          validStoresSearched = [];
          setStoreIds(validStoresSearched);
        }

        const updatedOffset = 0;
        setOffset(updatedOffset);
        callCreateOrderOpportunitiesApi(stores, updatedOffset);
      } else {
        const storeChannelKeys = Object.keys(validStoresObj);
        const validStores = [];
        storeChannelKeys.forEach((key) => {
          validStores.push(...validStoresObj[key]);
        });
        const storeArr = storeField.split(",").map((x) => parseInt(x));
        const invalidStores = [];

        storeArr.forEach(function (store) {
          if (validStores.indexOf(store) < 0) {
            invalidStores.push(store);
          } else {
            validStoresSearched.push(store);
          }
        });
        setStoreIds(validStoresSearched);
        if (storeTypeNew) {
          validStoresSearched = [];
          setStoreIds(validStoresSearched);
        }
        if (invalidStores.length > 0) {
          setStoreError(
            `The following store(s) are not valid: ${invalidStores.join(", ")}`
          );
        } else {
          setStoreError("");
        }
        const updatedOffset = 0;
        setOffset(updatedOffset);
        if (validStoresSearched.length > 0) {
          callCreateOrderOpportunitiesApi(validStoresSearched, updatedOffset);
        }
      }
    }
  };

  const callCreateOrderOpportunitiesApi = useCallback(
    (storeList, updatedOffset) => {
      let payload;
      let formattedFromDate;
      let formattedToDate;

      formattedFromDate =
        orderDateField === dayjs().format("DD/MM/YYYY")
          ? dayjs().format("YYYY-MM-DDTHH:mm:ss")
          : dayjs(orderDateField, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss");

      formattedToDate = orderDateField
        ? dayjs(orderDateField, "DD/MM/YYYY").format("YYYY-MM-DDT23:59:59")
        : "";

      const currentFormattedFromDate = dayjs().format("YYYY-MM-DDTHH:mm:ss");
      if (orderDateField !== null) {
        payload = {
          itemIds: minField
            ? minField.split(",").map((num) => Number(num))
            : undefined,
          packIds: pinField
            ? pinField.split(",").map((num) => Number(num))
            : undefined,
          shipToLocationIds: storeList
            ? storeList
            : storeIds?.length !== 0
            ? storeIds
            : storesFromStoreType?.length !== 0
            ? storesFromStoreType
            : undefined,
          shipFromLocationIds: depotField
            ? depotField.split(",").map((num) => Number(num))
            : undefined,
          orderDateFrom: orderDateField ? formattedFromDate : undefined,
          orderDateTo: orderDateField ? formattedToDate : undefined,
        };
      }
      if (orderDateField === null) {
        payload = {
          itemIds: minField
            ? minField.split(",").map((num) => Number(num))
            : undefined,
          packIds: pinField
            ? pinField.split(",").map((num) => Number(num))
            : undefined,
          shipToLocationIds: storeList
            ? storeList
            : storeIds?.length !== 0
            ? storeIds
            : storesFromStoreType?.length !== 0
            ? storesFromStoreType
            : undefined,
          shipFromLocationIds: depotField
            ? depotField.split(",").map((num) => Number(num))
            : undefined,
          orderDateFrom: currentFormattedFromDate,
        };
      }

      if (
        errorMessage === "" &&
        minError === "" &&
        pinError === "" &&
        depotError === "" &&
        mandatoryFieldsError === ""
      ) {
        dispatch(
          orderOpportunitiesInCreate({
            limit,
            offset: updatedOffset !== undefined ? updatedOffset : offset,
            payload,
          })
        );
      }
      setIsDisabled(false);
      setIsVisible(true);
    },
    [
      minField,
      pinField,
      offset,
      dispatch,
      depotField,
      limit,
      errorMessage,
      orderDateField,
      storeIds,
      storesFromStoreType,
      minError,
      pinError,
      depotError,
      mandatoryFieldsError,
    ]
  );

  const handleInfiniteScroll = useCallback(async () => {
    try {
      const { scrollTop, scrollHeight, clientHeight } =
        tableContainerRef?.current;
      if (
        scrollTop + clientHeight >= scrollHeight - 1 &&
        !isorderOpportunitiesLoading
      ) {
        setOffset(rows.length + selectedData.length);
      }
    } catch (error) {
      console.log(error, "error");
    }
  }, [isorderOpportunitiesLoading, tableContainerRef, rows, selectedData]);

  useEffect(() => {
    const tableContainer = tableContainerRef?.current;
    tableContainer?.addEventListener("scroll", handleInfiniteScroll);
    return () =>
      tableContainer?.removeEventListener("scroll", handleInfiniteScroll);
  }, [handleInfiniteScroll]);

  useEffect(() => {
    if (metadata?.next) {
      setDataLoadingByScroll(true);
      callCreateOrderOpportunitiesApi();
    }
  }, [offset]); //eslint-disable-line react-hooks/exhaustive-deps

  const handleQuantityChange = (id, value) => {
    const regex = /^(0?[1-9]{1,4}|[1-9][0-9]{0,3}|0)$/;
    let regexValue = regex.test(value);

    setRows((prevRows) => {
      const updatedRows = prevRows.map((row) =>
        row.id === id ? { ...row, quantity: regexValue ? value : "" } : row
      );
      const allBlankOrZero = updatedRows.every(
        (row) => !row.quantity || row.quantity === "0"
      );
      setDisableConfirmButton(allBlankOrZero);
      return updatedRows;
    });
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirm = () => {
    setConfirmQty(true);
    performCreate();
  };

  const handleClose = () => {
    setOpenStatus(false);
  };

  const inputRefs1 = useRef({}); // Reference to each DatePicker
  const handleOrderDateChange = useCallback((id, newDate) => {
    setRows((prevOrders) =>
      prevOrders.map((order) => {
        if (order.id === id) {
          return { ...order, orderDate: dayjs(newDate).format("YYYY-MM-DD") };
        }
        return order;
      })
    );
  }, []);

  useEffect(() => {
    if (openDialog) {
      setPopUpFlag(true);
    } else setPopUpFlag(false);
    if (isorderOpportunitiesError) {
      setRows([]);
    }
  }, [isorderOpportunitiesError, openDialog]);

  useEffect(() => {
    if (isCreateProcessOrderError && errMessageForCreate.httpResponseCode) {
      const { errTitle, errContent } =
        showErrorMessageByCode(isCreateProcessOrder);
      dispatch(showNotificationDialog(errTitle, errContent, "Done"));
    }
  }, [
    isCreateProcessOrder,
    dispatch,
    errMessageForCreate,
    isCreateProcessOrderError,
  ]);

  const handleDuplicate = () => {
    const multipleErrorsMsg = (
      <TableContainer
        component={Paper}
        sx={{ maxHeight: "250px", overflowY: "auto" }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#004E37", color: "white" }}>
              {headers?.map((header) => (
                <TableCell
                  key={header}
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "white",
                    backgroundColor: "#004E37",
                    padding: "3px",
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                  }}
                >
                  {headerMapping[header]} {/* Display custom header name */}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {selectedData?.map((data, index) => (
              <TableRow key={index}>
                {headers?.map((header) => (
                  <TableCell
                    key={header}
                    style={{
                      fontSize: "16px",
                      padding: "3px",
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                    }}
                  >
                    {data[header] !== undefined ? data[header] : "N/A"}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );

    dispatch(
      showNotificationDialogEmergencyOrder(
        "Below manual orders already exists:",
        multipleErrorsMsg,
        "Done"
      )
    );
  };
  const filterQuantity = rows?.filter(
    (row) =>
      row?.quantity !== "" &&
      row?.quantity !== null &&
      row?.quantity !== undefined
  );
  const createArrayForPayload = filterQuantity?.map((item) => ({
    packId: item?.packId,
    itemId: item?.itemId,
    packSize: item?.packSize,
    itemDescription: item?.itemDescription,
    shipFromLocationId: item?.shipFromLocationId,
    shipToLocationId: item?.shipToLocationId,
    orderDate: item?.orderDate,
    deliveryDate: item.deliveryDate,
    quantityOrdered: item?.quantity,
  }));

  const handleConfirmInCreate = () => {
    setRows([]);
    setSelectedData([]);
    setDuplicateError("");
    dispatch(resetOrderOpportunities());

    setSuccessPopupFlag(true);

    dispatch(
      createProcessOrder({
        orders: createArrayForPayload,
        action: ORDER_ACTIONS.CREATE,
      })
    );
  };

  return (
    <>
      {showSpinner && !isDataLoadingByScroll && (
        <Backdrop
          sx={{
            color: "#fff",
            flexDirection: "column",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={true}
        >
          <CircularProgress color="inherit" />

          <Typography variant="h6" sx={{ marginTop: 2 }}>
            Loading...
          </Typography>
        </Backdrop>
      )}
      <div>
        {quantityField !== "" && popUpFlag && (
          <ConfirmationDialog
            open={openDialog}
            onClose={handleCloseDialog}
            onConfirm={handleConfirm}
          />
        )}
      </div>
      <div className="alertMessage">
        {openStatus && duplicateError !== "" && (
          <Alert
            style={{ marginBottom: "2px" }}
            severity="warning"
            onClose={handleClose}
            className="iconButton"
            action={
              <IconButton color="inherit" size="small" onClick={handleClose}>
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          >
            <span className="duplicateErrorMsg">{duplicateError} </span>
            <Link
              style={{
                color: "#108810",
                cursor: "pointer",
                fontSize: "12px",
              }}
              onClick={handleDuplicate}
              className="clickView"
            >
              Click here to view
            </Link>
          </Alert>
        )}
      </div>

      <div className="labelControl">
        <Grid
          container
          spacing={2}
          style={{ marginBottom: "5px", fontSize: "15px" }}
        >
          <Grid item xs={12} sm={6} md={1.5} className="paddingTop0">
            <LabelWithControl label="Order Date">
              <DatePicker
                format="DD/MM/YYYY"
                disablePast={true}
                size="small"
                disabled={isDisabled}
                value={
                  orderDateField ? dayjs(orderDateField, "DD/MM/YYYY") : null
                }
                onChange={(x) => {
                  handleDateChange(x);
                }}
                slotProps={{
                  textField: {
                    size: "small",
                    placeholder: "Order Date",
                    helperText: error ? errorMessage : "",
                    error: error,
                    inputProps: { 'data-testid': 'order-date-input' },
                  },
                }}
              />
            </LabelWithControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3} className="paddingTop0">
            <LabelWithControl
              label={
                <>
                  MIN <span style={{ color: "red" }}>*</span> &nbsp;or&nbsp; PIN{" "}
                  <span style={{ color: "red" }}>*</span>
                </>
              }
            >
              {" "}
            </LabelWithControl>
            <TextField
              id="min"
              variant="outlined"
              size="small"
              placeholder="MIN"
              helperText={minError || ""}
              error={minError}
              value={minField}
              onChange={(e) => handleMinChange(e)}
              disabled={pinField.length > 0}
              style={{ width: "46%", display: "inline-block" }}
            />
            <TextField
              id="pin"
              variant="outlined"
              size="small"
              placeholder="PIN"
              helperText={pinError || ""}
              error={pinError}
              value={pinField}
              onChange={(e) => handlePinChange(e)}
              disabled={minField.length > 0}
              style={{
                width: "47%",
                display: "inline-block",
                marginLeft: "14px",
              }}
            />
          </Grid>

          <Grid xs={12} sm={6} item md={1} className="paddingTop0">
            <LabelWithControl label="Depot">
              <TextField
                id="depot"
                variant="outlined"
                size="small"
                placeholder="Depot"
                helperText={depotError || ""}
                error={depotError}
                value={depotField}
                onChange={(x) => handleDepotChange(x)}
                disabled={isDisabled}
                sx={{ marginLeft: "2px" }}
              />
            </LabelWithControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3} className="paddingTop0">
            <LabelWithControl
              label={
                <>
                  Store <span style={{ color: "red" }}>*</span> &nbsp;or&nbsp;
                  Store Type <span style={{ color: "red" }}>*</span>
                </>
              }
            >
              {" "}
            </LabelWithControl>
            <TextField
              id="store"
              variant="outlined"
              size="small"
              placeholder="Store"
              helperText={storeError || ""}
              error={storeError}
              value={storeField}
              onChange={(x) => handleStoreChange(x)}
              disabled={storeTypeNew.length !== 0}
              style={{ width: "46%", display: "inline-block" }}
            />

            <Select
              value={storeTypeNew || ""}
              onChange={handleStoreTypeChange}
              displayEmpty
              placeholder="Store Type"
              disabled={storeField.length !== 0}
              sx={{ height: "34px" }}
              className="dropDownValue"
              inputProps={{ "aria-label": "Without label" }}
              style={{
                width: "47%",
                display: "inline-block",
                marginLeft: "14px",
              }}
            >
              {storeTypes.map((store) => (
                <MenuItem key={store.id} value={store.id}>
                  {store.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>

          <Grid item xs={12} sm={6} md={1.5} className="paddingTop0">
            <LabelWithControl label="Quantity In Cases">
              <TextField
                id="quantity"
                variant="outlined"
                size="small"
                placeholder="Pre Populate Qty"
                helperText={quantityError || ""}
                error={quantityError}
                value={quantityField}
                onChange={(x) => handlePrepopulateQuantity(x)}
                disabled={isDisabled}
                inputProps={{ maxLength: 4 }}
              />
            </LabelWithControl>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={2}
            className="paddingTop0 commonButtons"
          >
            <Grid container style={{ display: "block" }}>
              {isVisible && (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      padding: "5px 10px",
                      height: "25px",
                      marginTop: "15px",
                      marginRight: "8px",
                    }}
                    onClick={() => {
                      handleCreate();
                    }}
                    size="small"
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      padding: "5px 10px",
                      marginTop: "18px",
                      marginRight: "8px",
                    }}
                  >
                    Create
                  </Button>
                </>
              )}

              <>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleReset}
                  size="small"
                  style={{
                    fontWeight: "bold",
                    fontSize: "12px",
                    margin: "15px 0 0",
                    padding: "5px 10px",
                    height: "25px",
                  }}
                >
                  Reset
                </Button>
              </>
              {/* )} */}
            </Grid>
          </Grid>
        </Grid>

        {mandatoryFieldsError !== "" && (
          <div className="error-display">
            <p style={{ color: "red", marginTop: "-10px" }}>
              {mandatoryFieldsError}
            </p>
          </div>
        )}
        {((items?.length !== undefined && items?.length > 0) ||
          errorDetails?.errorMessage) &&
          errorDetails?.errorMessage !== "Incorrect MIN/PIN number." && (
            <Grid>
              <TableContainer
                component={Paper}
                className="tableContainerScroll AmendWrapper tableStructure tableStyle tableStyleCreate"
                ref={tableContainerRef}
              >
                <Table sx={{ minWidth: 700 }}>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>MIN</StyledTableCell>
                      <StyledTableCell>PIN</StyledTableCell>
                      <StyledTableCell style={{ flex: 1, minWidth: 400 }}>
                        Description
                      </StyledTableCell>
                      <StyledTableCell>Pack Size</StyledTableCell>
                      <StyledTableCell>Depot ID</StyledTableCell>
                      <StyledTableCell>Current SOH</StyledTableCell>
                      <StyledTableCell>Store ID</StyledTableCell>
                      <StyledTableCell>Order Date</StyledTableCell>
                      <StyledTableCell style={{ flex: 1, minWidth: 100 }}>
                        Quantity In Cases
                      </StyledTableCell>
                      <StyledTableCell>Delivery Date</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {!isorderOpportunitiesError &&
                      rows !== undefined &&
                      rows?.length !== 0 &&
                      items &&
                      items?.length > 0 &&
                      createProcessOrderResponse === undefined &&
                      rows.map((item) => (
                        <StyledTableRow key={item.id}>
                          <StyledTableCell>{item.itemId}</StyledTableCell>

                          <StyledTableCell>{item.packId}</StyledTableCell>
                          <StyledTableCell style={{ flex: 1, minWidth: 100 }}>
                            <Tooltip title={item.itemDescription} arrow>
                              <span>{item.itemDescription}</span>
                            </Tooltip>
                          </StyledTableCell>

                          <StyledTableCell style={{ flex: 1, minWidth: 30 }}>
                            {item.packSize}
                          </StyledTableCell>
                          <StyledTableCell>
                            {item.shipFromLocationId}
                          </StyledTableCell>

                          <StyledTableCell>{item.soh}</StyledTableCell>

                          <StyledTableCell>
                            {item.shipToLocationId}
                          </StyledTableCell>

                          <StyledTableCell style={{ flex: 1, minWidth: 120 }}>
                            <div>
                              <DatePicker
                                className="inputBox"
                                value={dayjs(item.orderDate)}
                                onChange={(newValue) =>
                                  handleOrderDateChange(item.id, newValue)
                                }
                                format="DD/MM/YYYY"
                                disablePast={true}
                                size="small"
                                inputRef={(el) =>
                                  (inputRefs1.current[item.id] = el)
                                } // Maintain reference for focus control
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    placeholder: "Order Date",
                                    inputProps: { 'data-testid': 'order-date-input' },
                                  },
                                }}
                              />
                            </div>
                          </StyledTableCell>

                          <StyledTableCell className="quantityIcon">
                            <TextField
                              className="inputBox"
                              type="text"
                              value={item.quantity}
                              onChange={(e) =>
                                handleQuantityChange(item.id, e.target.value)
                              }
                              InputProps={{
                                style: {
                                  width: 60,
                                },
                              }}
                              inputProps={{
                                maxLength: 4,
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    border:
                                      item.quantity === "0"
                                        ? "2px solid #F28C28"
                                        : "1px solid none",
                                  },
                                  "&.Mui-focused fieldset": {
                                    border:
                                      item.quantity === "0"
                                        ? "2px solid #F28C28"
                                        : "1px solid none",
                                  },
                                  "&:hover fieldset": {
                                    border:
                                      item.quantity === "0"
                                        ? "2px solid #F28C28"
                                        : "1px solid none",
                                  },
                                },
                              }}
                            />
                            {item.quantity === "0" && (
                              <Tooltip title="Order quantity must be greater than zero.">
                                <InfoOutlinedIcon
                                  sx={{
                                    color: "#F28C28",
                                    marginTop: "8px",
                                    fontSize: "18px",
                                  }}
                                />
                              </Tooltip>
                            )}
                          </StyledTableCell>
                          <StyledTableCell>
                            {dayjs(item.deliveryDate).format("DD/MM/YYYY")}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    {isDataLoadingByScroll && (
                      <StyledTableRow>
                        <StyledTableCell
                          colSpan={14}
                          style={{
                            textAlign: "center",
                            position: "relative",
                            height: "100px",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              zIndex: 12,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CircularProgress />
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                    {!isDataLoadingByScroll &&
                      !showSpinner &&
                      errorDetails?.httpResponseCode && (
                        <TableCell colSpan={14} style={{ textAlign: "center" }}>
                          {errorDetails?.errorMessage ===
                            "No opportunities found for central supply chain" && (
                            <>No records found</>
                          )}
                          {errorDetails?.errorMessage !==
                            "No opportunities found for central supply chain" && (
                            <>{errorDetails?.errorMessage}</>
                          )}
                        </TableCell>
                      )}
                    {!isDataLoadingByScroll &&
                      !showSpinner &&
                      !errorDetails?.errorMessage &&
                      rows?.length === 0 && (
                        <TableCell colSpan={14} style={{ textAlign: "center" }}>
                          {rows?.length === 0 &&
                            !errorDetails?.errorMessage && (
                              <>No records found</>
                            )}
                        </TableCell>
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
              <div className="commonButtons commonButtonsMargin">
                <Grid
                  container
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "1.5rem",
                  }}
                >
                  <Grid item md={9.5}></Grid>

                  <Grid item md={1}>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ width: "100%" }}
                      disabled={disableConfirmButton}
                      fullWidth
                      onClick={handleConfirmInCreate}
                    >
                      Confirm
                    </Button>
                  </Grid>

                  <Grid item md={1}>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ width: "100%" }}
                      fullWidth
                      onClick={() => {
                        navigate(PAGE.HOME.url);
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          )}
      </div>
    </>
  );
};
